import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import type { ComponentProps } from 'react'
import React from 'react'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  memberPrice: number
  saleUnit?: string
  className?: string
}

/**
 * Displays the LuxPlus member price as a secondary caption-sized row,
 * matching the visual weight of PriceRowLuxPlusNonMemberPrice but with
 * LuxPlus branding (teal colour + logo).
 */
function PriceRowLuxPlusMemberPrice(props: Props) {
  const {
    memberPrice,
    saleUnit,
    signDisplay,
    className,
  } = props

  const sanitisedSaleUnit = saleUnit
    ? saleUnit.toLocaleLowerCase().replace(/^\//, '')
    : undefined
  const saleUnitLabel = sanitisedSaleUnit
    ? (/^(total|with)/.test(sanitisedSaleUnit) ? sanitisedSaleUnit : `/${sanitisedSaleUnit}`)
    : undefined

  return <Caption
    variant="medium"
    colour="lux-plus"
    className={className}
    weight="normal"
  >
    <b><FormatCurrency signDisplay={signDisplay} value={memberPrice} format="roundedDollar" /></b>
    {saleUnitLabel && <> {saleUnitLabel}</>}
    {' '}with&nbsp;<LuxPlusLogoWrapper height={8} />
  </Caption>
}

export default PriceRowLuxPlusMemberPrice
